import { query, collection, onSnapshot, addDoc, deleteDoc, doc, setDoc } from "firebase/firestore";
import { db, getCompanyId, getCurrentUserUID, sendError, getCurrentUser } from "./firebase";

const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotList: any[] = [];
var lastSnapshotMap = new Map();

export function registerDocumentTemplateSnapshotListener() {
    if (snapshotListener !== null) {
        return;
    }
    const q = query(collection(db, 'companies/' + getCompanyId() + '/documentTemplates'));
    //console.log("register documentTemplatesListener");
    snapshotListener = onSnapshot(q, (data: any) => {
        var list: { id: string; topic: string; text: string, userId: string, application:[] }[] = [];
        lastSnapshotMap.clear();
        data.forEach(function (doc: any) {
            let d = doc.data();
            let e = { id: doc.id, topic: d.topic, text: d.text, userId: d.userId, application:d.application  };
            list.push(e);
            lastSnapshotMap.set(doc.id, e);

        });
        //console.log(list);
        lastSnapshotList = list;
        listeners.forEach(callback => {
            callback(list);
        });


    }, (err) => {
        console.log("onDocumentTemplateChange error => " + err.message);
        sendError(err.message);
    })
}

export async function unregisterDocumentTemplateSnapshotListener() {
    if (snapshotListener !== null) {
        //console.log("unregister unregisterDocumentTemplateSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addDocumentTemplateListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshotList.length > 0) {
        callback(lastSnapshotList);
    }
}



export function getDocumentTemplates(all: boolean = false, application: number | undefined = undefined) {
    if (all) {
        return lastSnapshotList;
    } else {
        var l: any[] = [];
         lastSnapshotList.map((i) => {
            if (getCurrentUser().documentTemplates.includes(i.id)) {
                if(application !== undefined){
                    if(i.application.includes(application)){
                        l.push(i);
                    }
                }else{
                    l.push(i);
                }
                
            }
        })

        return l;
    }
}

export function getDocumentTemplate(id: string) {
    return lastSnapshotMap.get(id);
}

export async function addDocumentTemplate(data: { text: string, topic: string | number, application:[] }) {

    try {
        //@ts-ignore
        data.userId = getCurrentUserUID();
        await addDoc(collection(db, 'companies/' + getCompanyId() + '/documentTemplates'), data);
        return true;
    } catch (error) {
        console.error(error);
        sendError("Nie mozna dodać szablonu dokumentu!");
    }
    return false;
}

export async function setDocumentTemplate(data: { text: string, topic: string | number, application:[] }, id: string) {
    try {
        await setDoc(doc(db, 'companies/' + getCompanyId() + '/documentTemplates', id), data, { merge: true });
        return true;
    } catch (error) {
        console.error(error);
        sendError("Nie mozna poprawić szablonu dokumentu!");
    }
    return false;
}

export async function deleteDocumentTemplate(id: string) {
    try {
        await deleteDoc(doc(db, 'companies/' + getCompanyId() + '/documentTemplates', id));
        return true;
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć szablonu dokumentu!");
    }
    return false;
}